import type { ComponentPropsWithoutRef, FC, PropsWithChildren } from "react"
import { Link } from "react-router"

import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"
import { Icon } from "@/components/ui/icon"
import { cn } from "@/lib/utils"

type HeaderMenuProps = PropsWithChildren

type HeaderMenuActionLinkProps = ComponentPropsWithoutRef<typeof Link>

type HeaderMenuDrawerProps = PropsWithChildren<{
  contentClassName?: string
}>

type HeaderMenuDrawerLinkProps = ComponentPropsWithoutRef<typeof Link>

export const HeaderMenu: FC<HeaderMenuProps> = ({ children }) => {
  return <div className="flex h-full items-center">{children}</div>
}

export const HeaderMenuActionLink: FC<HeaderMenuActionLinkProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Link
      className={cn("px-2 text-[11px] font-semibold leading-[1.35] text-primary", className)}
      {...props}
    >
      {children}
    </Link>
  )
}

export const HeaderMenuDrawer: FC<HeaderMenuDrawerProps> = ({ children, contentClassName }) => {
  return (
    <Drawer direction="right">
      <DrawerTrigger asChild>
        <button
          type="button"
          aria-label="Open menu"
          className="mr-1 flex size-10 items-center justify-center rounded-full bg-highlight backdrop-blur-[10px]"
        >
          <Icon name="menu" className="size-6 text-text" />
        </button>
      </DrawerTrigger>
      <DrawerContent className={contentClassName}>
        <DrawerTitle className="sr-only">Menu</DrawerTitle>
        {children}
      </DrawerContent>
    </Drawer>
  )
}

export const HeaderMenuCloseButton: FC<{ className?: string }> = ({ className }) => {
  return (
    <DrawerClose asChild>
      <button type="button" className={className}>
        <Icon name="close" className="size-6 text-text" />
      </button>
    </DrawerClose>
  )
}

export const HeaderMenuDrawerLink: FC<HeaderMenuDrawerLinkProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <DrawerClose asChild>
      <Link className={className} {...props}>
        {children}
      </Link>
    </DrawerClose>
  )
}
